import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;
const API_URL = import.meta.env.VITE_API_URL;

const TeamService = {
    getAll: async () => axios.get(`${API_URL}/team/get/all`).then((data) => data).catch((err) => { throw err }),
    getUsersInTeam: async (id) => axios.get(`${API_URL}/team/${id}/users`).then((data) => data).catch((err) => { throw err }),
    getUsersNotInTeam: async (id) => axios.get(`${API_URL}/team/${id}/not-users`).then((data) => data).catch((err) => { throw err }),
    list: async () => axios.get(`${API_URL}/team/list`).then(({data}) => data.data).catch((err) => { throw err }),
    update: async (id, data) => axios.put(`${API_URL}/team/${id}`, data).then(({data}) => data).catch((err) => { throw err }),
    toggleStatus: async (id, data) => axios.put(`${API_URL}/team/status/${id}`, data).then(({data}) => data).catch((err) => { throw err }),
    save: async (data) => axios.post(`${API_URL}/team`, data).then(({data}) => data).catch((err) => { throw err }),
    getTeam: async (id) => axios.get(`${API_URL}/team/${id}`).then((data) => data.data).catch((err) => { throw err }),
    updateColor: (id, data) => axios.put(`${API_URL}/team/color/${id}`, data, {headers: {
            'Content-Type': 'application/json',
        }}).then((data) => data).catch((err) => { throw err }),
    getAllTeams: async () => axios.get(`${API_URL}/user/get/allTeams`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),
    attendanceTeams: async () => axios.get(`${API_URL}/team/get/attendanceTeams`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),
    encounterTeams: async () => axios.get(`${API_URL}/team/get/encounterTeams`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),
    boTeams: async () => axios.get(`${API_URL}/team/get/boTeams`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err })
};

export default TeamService;
